import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ChildCategoryListLayer from "../components/ChildCategoryListLayer";

const ChildCategoryListPage = () => {
    return (
        <MasterLayout>
            <ChildCategoryListLayer />
        </MasterLayout>
    );
};

export default ChildCategoryListPage;
